import * as stylex from '@stylexjs/stylex';
import type { ReactNode } from 'react';
import type { CellRendererValueProps } from '../cellRenderer.types';

export type IconTextProps = CellRendererValueProps<string> & {
  icon?: ReactNode;
  iconPosition?: 'before' | 'after';
  truncateText?: boolean;
};

/** Displays optional text and a caller-supplied icon, centering the icon when there is no text. */
export const IconText = ({ value, icon, iconPosition = 'before', truncateText = false }: IconTextProps) => {
  if (!value && !icon) return null;

  const iconContent = icon ? <span {...stylex.props(styles.icon)}>{icon}</span> : null;

  return (
    <div {...stylex.props(styles.root, !value && styles.iconOnly)}>
      {iconPosition === 'before' ? iconContent : null}
      {value ? <span {...stylex.props(truncateText && styles.truncatedText)}>{value}</span> : null}
      {iconPosition === 'after' ? iconContent : null}
    </div>
  );
};

const styles = stylex.create({
  root: { display: 'flex', height: '100%', alignItems: 'center', gap: '0.25rem' },
  icon: { display: 'flex', flexShrink: 0, alignItems: 'center' },
  iconOnly: { justifyContent: 'center' },
  truncatedText: { minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
});
